import Masonry from "masonry-layout";

export default defineNuxtPlugin((nuxtApp) => {
  window.Masonry = Masonry;

  return {
    provide: {
      Masonry,
    },
  };
});
